module.exports = __webpack_public_path__ + "img/proyecto_7_mv.8ce147fd.png";